import {inject, Injectable} from '@angular/core';
import {Router} from "@angular/router";
import {AuthService} from "./auth.service";
import {BehaviorSubject} from "rxjs";
import {ObjectUtils} from "../utils/object-utils";
import {StorageService} from "./storage.service";

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  isLogin = new BehaviorSubject<boolean>(false);
  currentUser = new BehaviorSubject<{ user?: any }>({});

  readonly isLoginKey = 'isLogin';
  readonly currentUserKey = 'currentUser';

  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly storageService = inject(StorageService);

  constructor() {
    const isLogin = this.storageService.getValue(this.isLoginKey) === 'true';
    const userStr = this.storageService.getValue(this.currentUserKey) ?? '{}';
    try {
      const user = JSON.parse(userStr);
      this.currentUser.next(user);
      this.isLogin.next(isLogin);
    } catch (e) {
      console.error('Failed to parse user:', e);
    }
    setTimeout(() => this.updateCurrentUser(), 0);
  }

  async updateCurrentUser() {
    const res: any = await this.authService.getCurrentUser();
    if (!res) {
      await this.Logout();
      return;
    }
    if (res.isSuccess) {
      const currentUser = {user: res.data};
      const previousUser = this.currentUser.value;

      // Check if same data
      if (this.isLogin.value && ObjectUtils.deepEqual(currentUser, previousUser))
        return;

      this.currentUser.next(currentUser);
      this.isLogin.next(true);
      this.storageService.setValue(this.currentUserKey, JSON.stringify(currentUser));
      this.storageService.setValue(this.isLoginKey, 'true');
    }
  }

  async Login() {
    await this.updateCurrentUser();
    await this.router.navigateByUrl('/dashboard');
  }

  async Logout() {
    const isLogin = this.storageService.getValue(this.isLoginKey) === 'true';
    if (!isLogin) return;

    this.storageService.setValue(this.isLoginKey, 'false');
    this.storageService.setValue(this.currentUserKey, JSON.stringify({}));
    await this.authService.logout();
    this.isLogin.next(false);
    await this.router.navigate(['/sign-in']);
  }
}
